import type { FlattenedCategoriesData } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/types";
import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import type { ColumnChartData, ColumnChartDataItems } from "pro-features/components/Chart/src/types";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";
import {
    CHANGE_METRIC,
    COLORS,
    MAX_COLUMNS_TO_DISPLAY,
} from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/const";
import { translate } from "app/filters/i18nFilter";
import { ALL } from "app/common/services/categoryService";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { PLAYERS_STATE } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/table-top/const";
import { EChartType } from "app/pages/industry-analysis/players/market-shares/types";

const { BLUE, LIGHT_BLUE, OTHER_CHART } = COLORS;

const getDisplayColumnChartData = (columnChartData: ColumnChartDataItems): ColumnChartDataItems => {
    if (columnChartData.length <= MAX_COLUMNS_TO_DISPLAY) {return columnChartData;}
    const slicedColumnChartData = columnChartData.slice(0, MAX_COLUMNS_TO_DISPLAY - 1);
    const others = translate("common.others");
    const initialOtherValue = {
        y: 0,
        color: OTHER_CHART,
        displayText: others.charAt(0).toUpperCase() + others.slice(1),
        labelChange: 0,
        weightedLabelChange: 0,
    };
    const other = columnChartData.slice(MAX_COLUMNS_TO_DISPLAY - 1).reduce((other: any, columnChartDataDataItem) => {
        const { y, weightedLabelChange } = other;
        const { labelChange: itemLabelChange, y: itemY } = columnChartDataDataItem;
        return {
            ...other,
            y: y + itemY,
            weightedLabelChange: weightedLabelChange + itemLabelChange * itemY,
        };
    }, initialOtherValue);
    other.labelChange = other.weightedLabelChange / other.y;
    const displayColumnChartData = [...slicedColumnChartData, other];
    return displayColumnChartData;
};

export const parse = (
    categoriesData: FlattenedCategoriesData = [],
    selectedCategory: IFlattenedCategory,
    trafficMetric: string,
): ColumnChartData => {
    const categoriesMap = CategoryServiceUtils.getCategoriesMap();
    const columnChartData = [];
    const params = proNavigator.getParams();
    categoriesData.forEach((categoryData) => {
        const categoryObject = categoriesMap[categoryData.Category];
        const isParent = !selectedCategory.isChild;
        const isParentWithNoChildren = isParent && selectedCategory.children.length === 0;
        const isBold =
            categoryData.Category === selectedCategory.forApi ||
            categoryData.Category === selectedCategory.parentItem?.forApi ||
            (isParentWithNoChildren && categoryObject.id === ALL);
        const navigationParams = {
            ...params,
            category: categoryObject.forUrl,
            marketSharesChartType: EChartType[EChartType.OVERTIME],
        };

        const columnChartDataItem = {
            y: categoryData[trafficMetric],
            labelChange: categoryData[CHANGE_METRIC],
            color: isBold ? BLUE : LIGHT_BLUE,
            displayText: categoryObject.text,
            onClick: () => proNavigator.go(PLAYERS_STATE, navigationParams),
        };
        columnChartData.push(columnChartDataItem);
    });
    const displayColumnChartData = getDisplayColumnChartData(columnChartData);
    return [{ data: displayColumnChartData }];
};
